import React from 'react'
import { Badge } from '@pdrj/pmi-iqos-ds-react'

const SpotServiceTypeBadge = ({ tags = [], serviceTypes = [] }) => {
  return tags.map(type => {
    const serviceType = serviceTypes.find(element => element.id === type)

    return serviceType && serviceType.tag ? (
      <Badge
        key={serviceType.id}
        text={serviceType.tag}
        defaultBg={Badge.defaultBackgrounds.colorContext}
      />
    ) : null
  })
}

export default SpotServiceTypeBadge
